var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2578_124168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2578_124168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_2",
    d: "M7.33325 11.333H8.66659V7.33301H7.33325V11.333ZM7.99992 5.99967C8.18881 5.99967 8.34714 5.93579 8.47492 5.80801C8.6027 5.68023 8.66659 5.5219 8.66659 5.33301C8.66659 5.14412 8.6027 4.98579 8.47492 4.85801C8.34714 4.73023 8.18881 4.66634 7.99992 4.66634C7.81103 4.66634 7.6527 4.73023 7.52492 4.85801C7.39714 4.98579 7.33325 5.14412 7.33325 5.33301C7.33325 5.5219 7.39714 5.68023 7.52492 5.80801C7.6527 5.93579 7.81103 5.99967 7.99992 5.99967ZM7.99992 14.6663C7.0777 14.6663 6.21103 14.4913 5.39992 14.1413C4.58881 13.7913 3.88325 13.3163 3.28325 12.7163C2.68325 12.1163 2.20825 11.4108 1.85825 10.5997C1.50825 9.78856 1.33325 8.9219 1.33325 7.99967C1.33325 7.07745 1.50825 6.21079 1.85825 5.39967C2.20825 4.58856 2.68325 3.88301 3.28325 3.28301C3.88325 2.68301 4.58881 2.20801 5.39992 1.85801C6.21103 1.50801 7.0777 1.33301 7.99992 1.33301C8.92214 1.33301 9.78881 1.50801 10.5999 1.85801C11.411 2.20801 12.1166 2.68301 12.7166 3.28301C13.3166 3.88301 13.7916 4.58856 14.1416 5.39967C14.4916 6.21079 14.6666 7.07745 14.6666 7.99967C14.6666 8.9219 14.4916 9.78856 14.1416 10.5997C13.7916 11.4108 13.3166 12.1163 12.7166 12.7163C12.1166 13.3163 11.411 13.7913 10.5999 14.1413C9.78881 14.4913 8.92214 14.6663 7.99992 14.6663Z",
    fill: "#4B6D98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.625ae7dd656f56ff832dc556df2b3cc2.svg";
export { ForwardRef as ReactComponent };